/**
 * The two faces the table is lettered in. Cinzel is drawn from Roman inscriptions
 * and carries the titles and the numbers that matter; Alegreya Sans is a humanist
 * sans that stays readable small. Both are bundled (OFL), so the table looks the
 * same offline and nothing is fetched from anyone else's server.
 *
 * The canvas rasterises text once, so a face that has not loaded yet would be
 * baked in as the fallback. `fontsReady` is awaited before the first frame.
 */
import '@fontsource/cinzel/600.css';
import '@fontsource/cinzel/700.css';
import '@fontsource/alegreya-sans/400.css';
import '@fontsource/alegreya-sans/500.css';
import '@fontsource/alegreya-sans/700.css';

export const DISPLAY_FACE = 'Cinzel';
export const TEXT_FACE = 'Alegreya Sans';

let ready: Promise<void> | null = null;

/** Resolves when both faces are ready, or after a short wait if they never come. */
export function fontsReady(): Promise<void> {
  ready ??= Promise.race([
    Promise.all([
      document.fonts.load(`600 16px "${DISPLAY_FACE}"`),
      document.fonts.load(`700 16px "${DISPLAY_FACE}"`),
      document.fonts.load(`400 16px "${TEXT_FACE}"`),
      document.fonts.load(`500 16px "${TEXT_FACE}"`),
      document.fonts.load(`700 16px "${TEXT_FACE}"`),
    ]).then(() => undefined),
    new Promise<void>((resolve) => window.setTimeout(resolve, 2500)),
  ]).catch(() => undefined);
  return ready;
}
